// Reusable component for displaying currency symbols
// MVR uses an image, others use text symbols

export default function CurrencySymbol({ currency, className = "" }) {
  if (currency === 'MVR') {
    return (
      <img 
        src="/images/rufiyaa-symbol.png" 
        alt="MVR" 
        className={`inline-block align-baseline ${className}`}
        style={{ height: '13px', width: 'auto', marginRight: '0.2em' }}
      />
    );
  }
  
  // Text-based symbols for other currencies
  const symbols = {
    'USD': '$',
    'CHN': '¥',
    'MVR': 'ރ. ',
  };
  
  // Handle undefined or null currency - return empty string or default symbol
  if (!currency) return <span className={className}>$</span>;
  
  return <span className={className}>{symbols[currency] || currency + ' '}</span>;
}

// Helper function for non-JSX contexts (e.g., generating strings)
export function getCurrencySymbolText(currency) {
  const symbols = {
    'USD': '$',
    'MVR': 'ރ. ',
    'CHN': '¥',
  };
  return symbols[currency] || currency + ' ';
}
